import React, { useEffect, useRef } from "react";
import DOMPurify from "dompurify";

type TShadowHTML = {
	html: string;
};

const ShadowHTML = ({ html }: TShadowHTML) => {
	const elem = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const el = elem.current;
		if (!el) return;

		let shadow = el.shadowRoot;

		if (!shadow) {
			shadow = el.attachShadow({ mode: "open" });
		}

		shadow.innerHTML = html ? DOMPurify.sanitize(html) : "";
	}, [html]);

	return <div ref={elem} />;
};

export default ShadowHTML;
